module.exports = __webpack_public_path__ + "img/func-keypal-2.d9ea97df.png";